import * as types from '../../actions/actiontypes';

export function setEngagementUpdateSuccessMessage(message) {
	return {
		type: types.SET_UPDATE_ENGAGEMENT_SUCCESS_MESSAGE,
		message: message
	};
}
